export function matchFamilyRule(params, isRoom, requoteMain = false) {
    const { adults, children, rooms } = params;
    const childrenCount = children.length;
    let roomsOverwrite = isRoom ? 1 : rooms;
    let rulesPax = {};
    let options = {
        adults,
        kids: childrenCount,
        kidsSlit: children,
        rooms: roomsOverwrite
    };


    if (requoteMain) {
        rulesPax = assingFamilyByRules(options)
    } else {
        rulesPax = assignFamily(options)
    }


    if (!rulesPax.distribution) {
        rulesPax.distribution = [];
        rulesPax.distribution.push(`${adults}${children.length > 0 ? '|' : ''}${children.map(child => child?.year).join(',')}`);
    }
    return {
        paxes: { adults: adults, children: children, rooms: rooms },
        adults: adults,
        children: childrenCount,
        paxesFormat: rulesPax.distribution,
        roomExtra: rulesPax.roomExtra
    };
}

export function assignFamily(params) {
    const { adults, kids, kidsSlit, rooms } = params;
    return distributePeople(adults, kids, rooms, kidsSlit);
}

export function assingFamilyByRules(params) {
    const { adults, kids, kidsSlit, rooms } = params;

    let rulesPaxes = {
        // 2 Adults cases
        "2x1": [`1|${kidsSlit[0]?.year}`, "2"],
        "2x2": [`1|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "1"],
        "2x3": [`1|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `1|${kidsSlit[2]?.year}`],
        "2x4": [`1|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `1|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`],
        "2x5": [`1|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `1|${kidsSlit[2]?.year},${kidsSlit[3]?.year},${kidsSlit[4]?.year}`],
        "2x6": [`1|${kidsSlit[0]?.year},${kidsSlit[1]?.year},${kidsSlit[2]?.year}`, `1|${kidsSlit[3]?.year},${kidsSlit[4]?.year},${kidsSlit[5]?.year}`],

        // 3 Adults cases
        "3x0": ["2", "1"],
        "3x1": [`2|${kidsSlit[0]?.year}`, "1"],
        "3x2": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "1"],
        "3x3": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `1|${kidsSlit[2]?.year}`],
        "3x4": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `1|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`],
        "3x5": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `3|${kidsSlit[2]?.year},${kidsSlit[3]?.year},${kidsSlit[4]?.year}`],
        "3x6": [`1|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `1|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `1|${kidsSlit[4]?.year},${kidsSlit[5]?.year}`],

        // 4 Adults cases
        "4x0": ["2", "2"],
        "4x1": [`2|${kidsSlit[0]?.year}`, "2"],
        "4x2": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "2"],
        "4x3": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year}`],
        "4x4": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`],
        "4x5": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year},${kidsSlit[4]?.year}`],
        "4x6": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year},${kidsSlit[2]?.year}`, `2|${kidsSlit[3]?.year},${kidsSlit[4]?.year},${kidsSlit[5]?.year}`],

        // 5 Adults cases
        "5x0": ["3", "2"],
        "5x1": [`2|${kidsSlit[0]?.year}`, "3"],
        "5x2": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "3"],
        "5x3": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `3|${kidsSlit[2]?.year}`],
        "5x4": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `3|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`],
        "5x5": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year},${kidsSlit[4]?.year}`, "1"],
        "5x6": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `1|${kidsSlit[4]?.year},${kidsSlit[5]?.year}`],

        // 6 Adults cases
        "6x0": ["3", "3"],
        "6x1": ["2", "2", `2|${kidsSlit[0]?.year}`],
        "6x2": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "2", "2"],
        "6x3": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year}`, "2"],
        "6x4": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, "2"],
        "6x5": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `2|${kidsSlit[4]?.year}`],
        "6x6": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `2|${kidsSlit[4]?.year},${kidsSlit[5]?.year}`],

        // 7 Adults cases
        "7x0": ["2", "2", "3"],
        "7x1": ["4", `3|${kidsSlit[0]?.year}`],
        "7x2": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "3", "2"],
        "7x3": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year}`, "3"],
        "7x4": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, "3"],
        "7x5": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `3|${kidsSlit[4]?.year}`],
        "7x6": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `2|${kidsSlit[4]?.year},${kidsSlit[5]?.year}`, "1"],

        // 8 Adults cases
        "8x0": ["4", "4"],
        "8x1": [`2|${kidsSlit[0]?.year}`,"2", "2","2"],
        "8x2": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, "3", "3"],
        "8x3": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year}`, "4"],
        "8x4": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, "4"],
        "8x5": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `2|${kidsSlit[4]?.year}`, "2"],
        "8x6": [`2|${kidsSlit[0]?.year},${kidsSlit[1]?.year}`, `2|${kidsSlit[2]?.year},${kidsSlit[3]?.year}`, `2|${kidsSlit[4]?.year},${kidsSlit[5]?.year}`, "2"]
    };

    return {
        distribution: rulesPaxes[`${adults}x${kids}`] || null,
        roomExtra: distributePeople(adults, kids, rooms, kidsSlit).roomExtra
    };
}

function distributePeople(adultos, menores, habitaciones, kidsSlit) {
    let roomExtraBand = false;
    if (adultos === 0) {
        return ["No hay adultos para distribuir."];
    }

    let adultosPorHabitacion = Math.ceil(adultos / habitaciones);
    const ninosPorHabitacion = Math.ceil(menores / habitaciones);

    let adultosRestantes = adultos;
    let ninosRestantes = Math.ceil(menores % habitaciones);

    const distribucion = [];

    for (let i = 0; i < habitaciones; i++) {
        const habitacion = [];
        if (adultosRestantes > 0) {
            habitacion.push(adultosPorHabitacion);
            adultosRestantes -= adultosPorHabitacion;
        } else {
            habitacion.push(adultosPorHabitacion + 1);
            roomExtraBand = true;
        }
        if ((adultos / habitaciones) % 2 != 0) {
            adultosPorHabitacion = Math.ceil(adultosRestantes / (habitaciones - (distribucion.length == 0 ? 1 : distribucion.length + 1)));
        }
        if (ninosRestantes > 0) {
            const edadesNiños = kidsSlit
                .slice(i * ninosPorHabitacion)
                .slice(0, (ninosRestantes > 0) ? ninosPorHabitacion : ninosPorHabitacion)
                .map(child => child?.year);

            if (edadesNiños.length > 0) {
                habitacion.push(edadesNiños.join(","));
                ninosRestantes--;
            }
        } else {
            const edadesNiños = kidsSlit
                .slice(i * ninosPorHabitacion)
                .slice(0, ninosPorHabitacion)
                .map(child => child?.year);

            if (edadesNiños.length > 0) {
                habitacion.push(edadesNiños.join(","));
            }
        }

        if (habitacion.length > 0) {
            distribucion.push(habitacion.join("|"));
        }
    }

    while (distribucion.length < habitaciones) {
        distribucion.push("1");
        roomExtraBand = true;
    }

    return { distribution: distribucion, roomExtra: roomExtraBand };
}






export function paxRateFamily(params) {
    let newPax = [];
    for (const param of params) {
        let paxSplit = param.split('|');
        let adults = paxSplit[0] ? Number(paxSplit[0]) : 0;
        let kidsSlit = paxSplit[1] ? paxSplit[1].split(',') : [];
        let kids = kidsSlit.map(kid => { return { year: Number(kid) } })
        newPax.push({ adults, children: kids })

    }

    return newPax;

}


export function familyRequote(quote, requote) {

    if (requote && requote.data && requote.data.tax) {
        for (const tax in requote.data.tax) {
            requote.data.tax[tax].isRequote = true;
        }
    }

    let newRate = { ...quote.data.rates, ...requote.data.rates }
    let newTax = { ...quote.data.tax, ...requote.data.tax }

    quote.data.rates = newRate;
    quote.data.tax = newTax;

    return quote;
}